
import { defineComponent, PropType } from 'vue';
import { IElForm } from '@/types/element';
import { ITheme } from '@/types/models';
import utils from '@/utils';
import api from '@/api/admin/themes';

export default defineComponent({
  emits: ['cancel', 'submit'],
  props: {
    theme: {
      type: Object as PropType<ITheme>,
      required: true,
    },
  },
  data() {
    return {
      form: { ...this.theme },
    };
  },
  methods: {
    apiSubmit() {
      api.submit(this.form, (res) => {
        if (!res) return;

        utils.success('模板状态设置成功！');
        this.$emit('submit', this.form);
      });
    },

    btnCancelClick() {
      this.$emit('cancel');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },
  },
  watch: {
    theme(value) {
      this.form = { ...value };
    },
  },
});
